import React from 'react';
import Header from '../Header/Header';
import MainDrawer from '../MainDrawer/MainDrawer';
import Main from '../Main/Main';
import './App.scss';
import styled from 'styled-components';

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  max-height: calc(100% - 80px);
`;

const App: React.FunctionComponent = () => {
  return (
    <div className="App">
      <Header />
      <BodyWrapper>
        <MainDrawer />
        <Main />
      </BodyWrapper>
    </div>
  );
};

export default App;
